import { render, staticRenderFns } from "./InfoBlock.vue?vue&type=template&id=e2f3d6d6"
import script from "./InfoBlock.vue?vue&type=script&lang=js"
export * from "./InfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports